import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { LovDTO } from '@api/ringil-api.v2.tsx';
import InputCustomDeclarant from '@components/framework/input/InputCustomDeclarant/InputCustomDeclarant.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  required?: boolean;
  readonly?: boolean;
  customDeclarationCompanies: LovDTO[];
  onChange: (customDeclarationCompanies: LovDTO[]) => void;
}

const InternalInfoCustomDeclarantTag: React.FC<ComponentProps> = ({ secured,
                                                                    readonly,
                                                                    required,
                                                                    customDeclarationCompanies,
                                                                    onChange,
                                                                  }) => {
  const [internalValue, setInternalValue] = useState(customDeclarationCompanies);
  const { tr } = useTranslationLgs();

  return (
    <>
      <ButtonTag secured={secured}
        label={tr('InternalInfoCustomDeclarantTag.disponent', 'Custom Declarant')}
        required={required}
        readonly={readonly}
        value={
          customDeclarationCompanies && customDeclarationCompanies.length > 0
            ? customDeclarationCompanies.map((company) => company.name).join(', ')
            : null
        }
        onSave={(onSuccess) => {
          onChange(internalValue);
          onSuccess();
        }}
        autoClose
        dataTestId="internalInfo-customDeclarant"
      >
        <InputCustomDeclarant
          values={internalValue}
          onChange={(value) => {
            setInternalValue(value);
          }}
          placeholder={tr('InternalInfoCustomDeclarantTag.selectCustomDeclarant', 'Select Custom Declarant')}
          dataTestId="internalInfo-customDeclarantList"
        />
      </ButtonTag>
    </>);

};

export default InternalInfoCustomDeclarantTag;